var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.55,
    height: 23,
    viewBox: "0 0 19.55 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-network") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-network"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_70",
    "data-name": "Capa 70"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6,4.1a1.3,1.3,0,0,1,2.6,0,1.3,1.3,0,0,1-2.6,0Zm.3,0a.9.9,0,1,0,.9-.9C16.3,3.1,15.9,3.5,15.9,4.1Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,7.9a1.58,1.58,0,0,0-1.7-1.4,1.52,1.52,0,0,0-1.7,1.4.2.2,0,1,1-.4,0,1.93,1.93,0,0,1,2.1-1.7,1.93,1.93,0,0,1,2.1,1.7.2.2,0,1,1-.4,0Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,5A4.12,4.12,0,0,1,16.7.9,4.19,4.19,0,0,1,20.8,5a4.1,4.1,0,0,1-8.2,0Zm.6,0a3.6,3.6,0,1,0,3.6-3.6A3.59,3.59,0,0,0,13.2,5Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,18.6a1.2,1.2,0,1,1,1.2,1.2A1.16,1.16,0,0,1,15.5,18.6Zm.4,0a.9.9,0,1,0,.9-.9A.9.9,0,0,0,15.9,18.6Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,22.2a1.48,1.48,0,0,0-1.6-1.3,1.48,1.48,0,0,0-1.6,1.3.2.2,0,1,1-.4,0,1.79,1.79,0,0,1,1.9-1.6,1.73,1.73,0,0,1,1.9,1.6.22.22,0,0,1-.2.2C18.2,22.4,18.3,22.3,18.3,22.2Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,19.4a4.12,4.12,0,0,1,4.1-4.1,4.1,4.1,0,0,1,0,8.2A4.12,4.12,0,0,1,12.5,19.4Zm.6,0a3.6,3.6,0,1,0,3.6-3.6A3.65,3.65,0,0,0,13.1,19.4Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_71",
    "data-name": "Capa 71"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.45,
    y1: 9,
    x2: 12.05,
    y2: 6.7,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_72",
    "data-name": "Capa 72"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.05,
    y1: 16.8,
    x2: 8.75,
    y2: 14,
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_68",
    "data-name": "Capa 68"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,11.3a1.6,1.6,0,1,1,1.6,1.6A1.58,1.58,0,0,1,4.9,11.3Zm.4,0a1.2,1.2,0,1,0,1.2-1.2A1.22,1.22,0,0,0,5.3,11.3Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,15.8c0-1-1-1.7-2.2-1.7a2,2,0,0,0-2.2,1.7.2.2,0,0,1-.4,0,2.39,2.39,0,0,1,2.6-2.1A2.46,2.46,0,0,1,9,15.8a.2.2,0,0,1-.4,0Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,12.4a4.7,4.7,0,1,1,4.7,4.7A4.69,4.69,0,0,1,1.7,12.4Zm.6,0a4.12,4.12,0,0,0,4.1,4.1,4.05,4.05,0,1,0,0-8.1A4.1,4.1,0,0,0,2.3,12.4Z",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.45 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.45 -0.7)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNetwork);
export default __webpack_public_path__ + "static/media/user-network.f404cd606963e7770e4906eb8ab3ebc8.svg";
export { ForwardRef as ReactComponent };